import { cs2Constants } from '../_constants';
import { cs2Service } from '../_services';
import { alertActions } from './'; 
import { parseString } from 'xml2js';


export const cs2Actions = {
		cs2Executions,
		cs2SubmissionLog,
		cs2FileSubmission,
		cs2FirmGroup
};

function cs2Executions(tdate) {
	
    return dispatch => {
    	
        dispatch(request({ tdate }));
        
        console.log("cs2Executions request" + JSON.stringify(tdate));
        
        /*
         * TODO  history.push(from); when its successful
         */
        //cs2Service.getExecutions(JSON.stringify(tdate))
        cs2Service.getExecutions(tdate)
        .then(
            executions => dispatch(success(executions)),
            error => { 
            	dispatch(failure(error.toString()));
            	dispatch(alertActions.error(error.toString()));
            }
        );
        
    };

    function request(executions) { 
    	return { type: cs2Constants.EXECUTIONS_REQUEST, executions } 
    }
    
    function success(executions) { 
    	return { type: cs2Constants.EXECUTIONS_SUCCESS, executions } 
	}
    
    function failure(error) { 
    	return { type: cs2Constants.EXECUTIONS_FAILURE, error } 
    }
    
}


function cs2FileSubmission(xmlString) {
	
    return dispatch => {
    	
		dispatch(request({ xmlString }));
        
        //console.log("cs2 file submission request" + JSON.stringify(xmlString));
      
        cs2Service.fileSubmission(xmlString)
        .then(
            executions => {
            	dispatch(success(executions));
            	parseString(executions.result, function (err, result) {
					//var message = executions.message == 'Fail' ? result.response.error[0].$.type : result.response.success[0].$.type;
					//dispatch(alertActions.success("File Loading Status: " + executions.message + " - " + message));
					
					if (executions.message == 'Fail') {
						const message = {"type": result.response.error[0].$.type, "code": result.response.error[0].$.code, "description": result.response.error[0].$.description == "null" ? "" : result.response.error[0].$.description };
						//dispatch(alertActions.fileUploadError("Status: (" + executions.message + ") - " + result.response.error[0].$.type + " : " + result.response.error[0].$.description ) );
						dispatch(alertActions.error(message));
						
					} else if (executions.message == 'Success') {
						//dispatch(alertActions.success("Status: (" + executions.message + ") - File loaded successfully"));
						const message = {"type": "Loaded Successfully", "code": "", "description": "File loaded successfully into CS2" }
						dispatch(alertActions.success(message));
						
					} else {
						const message = {"type": "Fail", "code": "", "description": executions.message }
						dispatch(alertActions.error(message));
					}
                	
            	});
            },
            error => { 
            	dispatch(failure(error.toString()));
            	dispatch(alertActions.error(error.toString()));
            }
        );
        
    };

    function request(xmlString) { return { type: cs2Constants.FILE_SUBMISSION_REQUEST, xmlString } }    
    function success(submissionResponse) { return { type: cs2Constants.FILE_SUBMISSION_SUCCESS, submissionResponse } }
    function failure(error) { return { type: cs2Constants.FILE_SUBMISSION_FAILURE, error } }
}


function cs2SubmissionLog() {
	
	return dispatch => {
		
		dispatch(request());
		
		cs2Service.getSubmissionLogs()
		.then(
				submissionLog => dispatch(success(submissionLog)),
				error => dispatch(failure(error.toString()))
		);
		
	};
	
	function request() { return { type: cs2Constants.SUBMISSION_LOG_REQUEST }}
	function success(submissionLog) { return { type: cs2Constants.SUBMISSION_LOG_SUCCESS, submissionLog }}
	function failure(error) { return { type: cs2Constants.SUBMISSION_LOG_FAILURE, error }}
}

function cs2FirmGroup() {
	
	return dispatch => {
		
		dispatch(request());
		
		cs2Service.getFirmGroupList()
		.then(
				firmGroupList => dispatch(success(firmGroupList)),
				error => dispatch(failure(error.toString()))
				)
	};
	
	function request() { return { type: cs2Constants.FIRM_GROUP_REQUEST}}
	function success(firmGroupList) { return { type: cs2Constants.FIRM_GROUP_SUCCESS, firmGroupList }}
	function failure(error) { return { type: cs2Constants.FIRM_GROUP_FAILURE, error }}
}